/**
 * The user facing reference of a ToE: the bank reference / EV number on bank
 * reports, the proposal ref no. otherwise. Falls back to the legacy ToE ID
 * (`name`) so records created before those fields existed still show something.
 */
export function getToeRef(toe: {
    is_bank_report?: boolean | number,
    ev_number?: string,
    proposal_ref_num?: string,
    name?: string
}): string {
    if (!toe) {
        return '';
    }

    const ref = toe.is_bank_report ? toe.ev_number : toe.proposal_ref_num;

    return ref || toe.name || '';
}
